// V2 Sandbox maps XX_MicrositeResellerAttributes.PrimaryColor names to theme hex values.
// SAM10-SANDBOX: mostly '' or 'Blue' (2360 rows), one 'RED'.
const RESELLER_PRIMARY_COLORS = {
  Blue: '#00000b',
  RED: '#b71c1c'
}

const DEFAULT_PRIMARY = RESELLER_PRIMARY_COLORS.Blue
const DEFAULT_ON_PRIMARY = '#edf0f2'

export function resolvePrimaryColor(value) {
  if (!value) return DEFAULT_PRIMARY
  if (value.startsWith('#')) return value
  return RESELLER_PRIMARY_COLORS[value] || DEFAULT_PRIMARY
}

export function resolveOnPrimaryColor() {
  return DEFAULT_ON_PRIMARY
}
